import type { Frame } from "../events";
import type { ReactNode } from "react";

export type FrameRenderer = (frame: Frame) => ReactNode;
export type FrameRendererMap = Record<string, FrameRenderer>;

export interface FrameRegistry {
  getRenderer(kind: string): FrameRenderer | undefined;
  rendererFor(frame: Frame): FrameRenderer | null;
}

export function createFrameRegistry(map: FrameRendererMap): FrameRegistry {
  return {
    getRenderer(kind) {
      return map[kind];
    },
    rendererFor(frame) {
      return map[frame.kind] ?? null;
    },
  };
}
